import type { ReactNode } from "react";
import heidiRun from "../../../heidi-run.gif";

export function newId() {
  return crypto.randomUUID();
}

function initials(name: string) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function IconButton({
  label,
  active,
  partial,
  children,
  onClick,
  onMouseDown,
  disabled,
}: {
  label: string;
  active?: boolean;
  partial?: boolean;
  children: ReactNode;
  onClick?: () => void;
  onMouseDown?: (event: React.MouseEvent) => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={`icon-button ${active ? "active" : ""} ${partial ? "partial" : ""}`}
      aria-label={label}
      title={label}
      aria-pressed={active || partial}
      onMouseDown={(event) => {
        event.preventDefault();
        onMouseDown?.(event);
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function Avatar({ name, src, size = 38 }: { name: string; src?: string; size?: number }) {
  if (src) return <img className="avatar" src={src} alt="" width={size} height={size} />;
  return (
    <span className="avatar avatar-fallback" style={{ width: size, height: size, fontSize: Math.max(10, size * 0.28) }}>
      {initials(name)}
    </span>
  );
}

export function LoadingRaccoon({ size = 22 }: { size?: number }) {
  return <img className="loading-raccoon" src={heidiRun} alt="Loading" style={{ width: size, height: size }} />;
}
